module.exports = __webpack_public_path__ + "img/bg_5.3fe16641.png";